export default {
  "pl": {
    "integration_error": {
      "customer": {
        "first_name": {
          "blank": "Należy podać imię."
        },
        "last_name": {
          "blank": "Należy podać nazwisko."
        },
        "phone": {
          "blank": "Należy podać numer telefonu."
        },
        "user": {
          "taken": "Należy podać unikatowy adres e-mail."
        }
      }
    }
  }
}
